'use client';

import { useState, useEffect, useRef } from 'react';
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";

export default function ScrollGuideButton() {
  const [showScrollDown, setShowScrollDown] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const hasScrolled = useRef(false);

  // Check scroll position
  const checkScrollPosition = () => {
    const scrolled = window.scrollY > 100;
    
    if (scrolled) {
      hasScrolled.current = true;
    }
    
    // Show scroll down button only at the beginning if not scrolled yet
    setShowScrollDown(!hasScrolled.current);
    
    // Show scroll to top button when scrolled down 300px
    setShowScrollTop(window.scrollY > 300);
  };

  // Scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Scroll down by one viewport height
  const scrollDown = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
    hasScrolled.current = true;
    setShowScrollDown(false);
  };

  useEffect(() => {
    checkScrollPosition(); // Initial check
    
    window.addEventListener('scroll', checkScrollPosition);
    return () => window.removeEventListener('scroll', checkScrollPosition);
  }, []);

  // Hide scroll down button after 5 seconds automatically
  useEffect(() => {
    const timer = setTimeout(() => {
      if (showScrollDown && !hasScrolled.current) {
        setShowScrollDown(false);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [showScrollDown]);

  return (
    <div className="fixed bottom-8 right-8 z-50">
      {/* Scroll Down Button (shown at beginning) */}
      {showScrollDown && (
        <button
          onClick={scrollDown}
          className="p-1 bg-secondary text-yel rounded-full shadow-lg hover:bg-bl-dark transition-all bg-opacity-40 animate-bounce"
          aria-label="Scroll down"
        >
          <MdKeyboardArrowDown size={40} className='hover:text-bl font-bold'/>
        </button>
      )}

      {/* Scroll to Top Button (shown when scrolled down) */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="p-1 bg-secondary text-yel rounded-full shadow-lg hover:bg-bl-dark transition-all bg-opacity-40"
          aria-label="Scroll to top"
        >
          <MdKeyboardArrowUp size={40} className='hover:text-bl font-bold'/>
        </button>
      )}
    </div>
  );
}